import * as React from "react";

function RexelUsaIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 75 28"
    >
      <defs>
        <clipPath>
          <rect width="75" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-rexel-usa)">
        <path
          data-name="Path 7142"
          d="M-34.231-15.4h7.722a4.076,4.076,0,0,1,2.871,1,3.4,3.4,0,0,1,1.089,2.629v1.584a3.118,3.118,0,0,1-.715,2.024,4.018,4.018,0,0,1-1.947,1.276v.022a4.725,4.725,0,0,1,1.936,2.816L-22.065,0h-2.156l-1.188-3.96a3.414,3.414,0,0,0-.979-1.628,2.242,2.242,0,0,0-1.529-.594h-4.224V0h-2.09Zm7.15,7.37a2.573,2.573,0,0,0,1.771-.594,1.986,1.986,0,0,0,.671-1.562v-1.606a1.649,1.649,0,0,0-.528-1.276,1.971,1.971,0,0,0-1.386-.484h-5.588V-8.03ZM-14.541.24a5.568,5.568,0,0,1-4.05-1.485,5.246,5.246,0,0,1-1.53-3.945V-9.48a5.709,5.709,0,0,1,1.53-4.155,5.389,5.389,0,0,1,4.05-1.575h2.46a5.121,5.121,0,0,1,3.87,1.53,5.6,5.6,0,0,1,1.47,4.05v2.64h-11.22v1.8a3.489,3.489,0,0,0,.945,2.535,3.291,3.291,0,0,0,2.475.975h2.28A3.526,3.526,0,0,0-9.831-2.5,2.8,2.8,0,0,0-8.9-4.71h2.1A4.617,4.617,0,0,1-8.3-1.125,5.656,5.656,0,0,1-12.261.24ZM-8.9-8.85v-.78a3.913,3.913,0,0,0-.87-2.655,2.9,2.9,0,0,0-2.31-1.005h-2.46a3.172,3.172,0,0,0-2.475,1.05,3.969,3.969,0,0,0-.945,2.76v.63Zm8.714,1L-5.4-15.4h2.376L1-9.57,5.027-15.4H7.381L2.167-7.854,7.6,0H5.225L1-6.138-3.245,0H-5.621ZM14.641.24a5.568,5.568,0,0,1-4.05-1.485A5.246,5.246,0,0,1,9.061-5.19V-9.48a5.709,5.709,0,0,1,1.53-4.155,5.389,5.389,0,0,1,4.05-1.575H17.1a5.121,5.121,0,0,1,3.87,1.53,5.6,5.6,0,0,1,1.47,4.05v2.64H11.221v1.8a3.489,3.489,0,0,0,.945,2.535,3.291,3.291,0,0,0,2.475.975h2.28a3.526,3.526,0,0,0,2.43-.825,2.8,2.8,0,0,0,.93-2.205h2.1a4.617,4.617,0,0,1-1.5,3.585A5.656,5.656,0,0,1,16.921.24Zm5.64-9.09v-.78a3.913,3.913,0,0,0-.87-2.655A2.9,2.9,0,0,0,17.1-13.29h-2.46a3.172,3.172,0,0,0-2.475,1.05,3.969,3.969,0,0,0-.945,2.76v.63ZM26.641,0A1.673,1.673,0,0,1,25.42-.44a1.583,1.583,0,0,1-.451-1.188V-15.4h2.09V-1.848h8.36V0Z"
          transform="translate(37 22)"
          fill="#1d2298"
        />
      </g>
    </svg>
  );
}

export default RexelUsaIcon;
